import React from 'react'

import ContentHeader from '../../components/ContentHeader'

class Header extends React.PureComponent {
  render() {
    return (
      <ContentHeader
        title="REPORT: Quarterly Route Cost Analysis"
        showBackButton
      />
    )
  }
}

export default Header
